const i18n = {
	complaint: {
		1 : 'Жалоба на:',
		0 : 'Скрага на:'
	},
}

export default i18n
